import { getActiveProfile } from "../auth/profiles";

export type AuthContext = "user" | "business";

/**
 * The auth context requests run under, mirroring the backend's
 * `authenticated_as_user?`: OAuth profiles send a user token, API-key
 * profiles and WHOP_API_KEY send a business-account key. Null when not
 * logged in at all.
 */
export function activeAuthContext(): AuthContext | null {
	const profile = getActiveProfile();
	if (profile) return profile.method === "oauth" ? "user" : "business";
	return process.env.WHOP_API_KEY ? "business" : null;
}

export interface RequiredOverride {
	name: string;
	prompt: string;
	error: string;
}

/**
 * Params the API technically accepts as optional but that fall back to
 * confusing defaults, so the CLI treats them as required. Keyed by request
 * shape (not command name) so both the interactive prompt flow and the fetch
 * proxy enforce the same rules.
 */
export function requiredOverrides(
	method: string,
	pathname: string,
	context: AuthContext,
): RequiredOverride[] {
	if (method.toUpperCase() === "POST" && pathname === "/accounts") {
		return context === "user"
			? [
					{
						name: "title",
						prompt: "Name for the new business account",
						error:
							"title is required. Pass --title to name the new business account.",
					},
				]
			: [
					{
						name: "email",
						prompt: "Email of the user who will own the connected account",
						error:
							"email is required. Pass --email with the owner's email to create a connected account.",
					},
				];
	}
	return [];
}

export function hasRequiredOverrides(
	method: string,
	pathname: string,
): boolean {
	return (
		requiredOverrides(method, pathname, "user").length > 0 ||
		requiredOverrides(method, pathname, "business").length > 0
	);
}
